export interface PkcePair {
  verifier: string;
  challenge: string;
  state: string;
}

function base64UrlEncode(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

export function generateVerifier(length = 64): string {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  const encoded = base64UrlEncode(bytes);
  // Trim to requested length within PKCE allowed range (43-128)
  const clampedLength = Math.max(43, Math.min(128, length));
  return encoded.slice(0, clampedLength);
}

export async function deriveChallenge(verifier: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode(new Uint8Array(digest));
}

export function generateState(length = 32): string {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  return base64UrlEncode(bytes).slice(0, length);
}

export async function generatePkcePair(): Promise<PkcePair> {
  const verifier = generateVerifier();
  const challenge = await deriveChallenge(verifier);
  const state = generateState();
  return { verifier, challenge, state };
}
